import { get } from 'lodash';
import { onINP } from 'web-vitals';
import { canUseDOM } from '../executionEnvironment';
import { trackLinkEvent } from '../tealium/tealium';
import { asInt } from '../cmsHelper/cmsHelper';
import {
  DOM_NODE_STRING_LIMIT,
  INP_TRACKING_PAGE_LEVEL_FLAG,
  INP_TRACKING_INITIALIZED,
  INP_EVENT_NAME,
  INP_LOWER_BOUND_CMS_LABEL,
  DEFAULT_INP_LOWER_BOUND,
  INP_TRACKING_GLOBAL_FLAG,
} from './constants';

/**
 * Uses tealium to track INP data.
 * @param {object} data INP event data.
 */
export const trackInpEvent = data => {
  const { value, entries = [], rating } = data || {};
  const { target } = entries[0] || {};

  if (!canUseDOM || !target) {
    return;
  }

  const cmsGlobal = get(window, 'ASOData.uiConfig.cmsGlobal', {});
  const threshold = asInt(cmsGlobal[INP_LOWER_BOUND_CMS_LABEL], DEFAULT_INP_LOWER_BOUND);

  if (value > threshold) {
    trackLinkEvent({
      event: INP_EVENT_NAME,
      inpValue: value,
      inpRating: rating,
      inpDomNode: target.outerHTML.slice(0, DOM_NODE_STRING_LIMIT),
    });
  }
};

/**
 * Calling onINP more than once per page can result in memory leaks.
 * Calls function to initialize a performance observer for INP events. Returns true if the function was called or false if the function was already called.
 * @returns {boolean}
 */
export const initializeInpTracking = () => {
  if (
    canUseDOM &&
    !window[INP_TRACKING_INITIALIZED] &&
    (get(window.ASOData.uiConfig.cmsGlobal, INP_TRACKING_GLOBAL_FLAG) || get(window.ASOData.uiConfig.flags, INP_TRACKING_PAGE_LEVEL_FLAG))
  ) {
    onINP(trackInpEvent, { reportAllChanges: true });
    window[INP_TRACKING_INITIALIZED] = true;
    return true;
  }
  return false;
};
